import { KnownFlag } from "./types";
import { useFlagVersion } from "./useFlagVersion";

export type KnownFlagShort = "semanticLibrarySearch";

const toLong = (short: KnownFlagShort | undefined): KnownFlag | undefined =>
  short ? `${short}Version` : undefined;

export const useIsOn = (flagShort: KnownFlagShort | undefined): boolean => {
  const flag = toLong(flagShort);
  const version = useFlagVersion(flag);

  return version > -1;
};
